"use client";
import React from "react";
import classes from "./index.module.css";
import { Close, Gift } from "../Icons";
import { useTranslation } from "@/i18n/client";
import { useMediaQuery } from "@mantine/hooks";
import { theme } from "@/theme";
import Text from "@/components/Text";
import ActionIcon from "../ActionIcon";

interface InfoBannerProps {
  noAssignedBonus: boolean;
}

let bannerClosed = false;

export const InfoBanner = ({ noAssignedBonus }: InfoBannerProps) => {
  const { t } = useTranslation("components");
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints?.xs})`) ?? true;
  const [isClosed, setIsClosed] = React.useState(bannerClosed);

  const close = () => {
    bannerClosed = true;
    setIsClosed(true);
  };

  if (isClosed) {
    return null;
  }

  return (
    <div className={classes.infoBanner}>
      {noAssignedBonus ? (
        <>
          <Text variant="reading_small">{t("InfoBanner.nonsuccessText")}</Text>
          <ActionIcon variant="transparent" size="xs" onClick={close} className={classes.closeIcon}>
            <Close />
          </ActionIcon>
        </>
      ) : (
        <>
          <Gift width={24} height={24} />
          {isDesktop ? (
            <>
              <Text variant="reading_small_bold">{t("InfoBanner.defaultBoldText")}</Text>
              <Text variant="reading_small"> {t("InfoBanner.defaultText")}</Text>
            </>
          ) : (
            <>
              <Text variant="reading_small_bold">{t("InfoBanner.defaultTextMobile")}</Text>
            </>
          )}
          <ActionIcon variant="transparent" size="xs" onClick={close} className={classes.closeIcon}>
            <Close />
          </ActionIcon>
        </>
      )}
    </div>
  );
};
